
<a class="learning-path-card" [routerLink]="[getCardLink()]">
  <img
    class="learning-path-image"
    [src]="learningPath.imageFile?.fileUrl"
    appTrainingImageFallback
  />
  <div class="learning-path-details">
    <div>
      <h2 class="learning-path-name">{{ learningPath.name }}</h2>
      <div class="learning-path-description">
        {{ learningPath.description }}
      </div>
    </div>
    <!-- <div>
      <div class="learning-path-badge">
        <div class="learning-path-badge-container">
          <div class="learning-path-badge-content">
            <i
              class="dx-icon dx-svg-icon play-icon"
              [innerHTML]="getCategoryIcon()"
            ></i>
            {{ category.trainings.length }}
            {{ "TRAINING-CATALOGUE.OVERVIEW.TRAININGS" | translate }}
          </div>
        </div>
        <div class="learning-path-badge-container">
          <div class="learning-path-badge-content">
            <i
              class="dx-icon dx-svg-icon play-icon"
              [innerHTML]="getPlayIcon()"
            ></i>
            {{ category.courses.length }}
            {{ "TRAINING-CATALOGUE.OVERVIEW.COURSES" | translate }}
          </div>
        </div>
      </div>
    </div> -->
  </div>
</a>

